module.exports = __webpack_public_path__ + "static/media/kia.bbbf6bea.png";